import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function ChampionshipProvider({ children }) {
  const [current, setCurrent] = useState(null);
  const [all, setAll] = useState([]);
  const [siteAssets, setSiteAssets] = useState({});
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [c, list] = await Promise.all([
        api.get("/championships/current").catch(() => ({ data: null })),
        api.get("/championships").catch(() => ({ data: [] })),
      ]);
      setCurrent(c.data);
      setAll(list.data || []);
      if (c.data?.id) {
        const [a, d] = await Promise.all([
          api.get(`/championships/${c.data.id}/site-assets`).catch(() => ({ data: {} })),
          api.get(`/championships/${c.data.id}/documents`).catch(() => ({ data: [] })),
        ]);
        setSiteAssets(a.data || {});
        setDocuments(d.data || []);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const value = useMemo(
    () => ({ current, all, siteAssets, documents, loading, reload: load, setCurrent }),
    [current, all, siteAssets, documents, loading, load],
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useChampionship = () => useContext(Ctx);
